/**
 * @license
 * Copyright 2019 Google LLC. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
// Initialize and add the map
window.initMap = async function () {

    const mapElement = document.getElementById("location-map-canvas");

    if (!mapElement) return;

    const lat = parseFloat(mapElement.dataset.lat);
    const lng = parseFloat(mapElement.dataset.lng);

    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

const marker = mapElement.dataset.marker;

const flagImg = document.createElement("img");
flagImg.src = marker;
	
	const map = new Map(mapElement, {
    center: { lat, lng },
    zoom: 15,
    mapId: mapElement.dataset.mapId,
});

    new AdvancedMarkerElement({
        map,
        position: { lat, lng },
        content: flagImg,
    });

};